import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-coupon",
  "use": "icon-coupon-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1000 1000\" id=\"icon-coupon\"><path d=\"M400,550h300v66.7H400V550z M400,383.3h300V450H400V383.3z M200,166.7h66.7v666.7H200V166.7z M933.3,329.2V166.7H66.7v666.7\n  h866.7V670.8C865,644.2,816.7,577.7,816.7,500S865,355.8,933.3,329.2z M1000,316.7v66.7c-64.4,0-116.7,52.2-116.7,116.7\n  s52.2,116.7,116.7,116.7v66.7V900H0V100h1000V316.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/coupon.svg
// module id = 1Fjq
// module chunks = 28